import { IInteractive } from "../interfaces/IInteractive";
import { GetBoundsCollection } from "../utils/GetBoundsCollection";


/**
 * links specific child view to it's state texture definitions
 */
//  export type UpdateInteractiveViewDef = {
//     view: Phaser.GameObjects.GameObject;
//     statesTextureData: TextureStatesData;
// }
// export type UpdateInteractiveViewDef = {
//     view: Phaser.GameObjects.Image | Phaser.GameObjects.Text;
//     textureStates?: TextureStatesData,
//     /**
//      * Toggle buttons have their extra out/disabled toggle texture states (over unused)
//      */
//     textureToggleStates?: TextureStatesData,
//     textStates?: TextStatesData,
// }

export class Interactive
    extends Phaser.GameObjects.Container
    implements IInteractive
{
    protected isInteractive: boolean;
    /**
     * Child views whos view changes based on the 'interactive' state of parent 
     * (that this Mixin was mixed into)
     * NOTE: this does not affect individual view's interactivity, 
     *       by default we should prob just use hitArea overlay on parent
     *       to avoid confusion of individual viwes being enabled/disabled 
     *       (which they are not; only visually and all at once)
     */
    // protected updateInteractiveViews: UpdateInteractiveViewDef[];
    
    // cache area/callback for when dsabled (this.input==null)
    protected cachedHitArea: any;
    protected cachedHitAreaCallback: Phaser.Types.Input.HitAreaCallback;

    // NOTE: debug outlines position/scale VISUAL bugged on containers (but they work correctly)
    protected debug: boolean = true;

    /**
     * NOTE: in mixins, you need to call this additionally, since debug prop
     *       is purged once merged.
     * @param enabled 
     */
    public SetDebug(enabled: boolean): void
    {
        this.debug = enabled;
    }
    
    // public AddInteractiveViewDef(def: UpdateInteractiveViewDef) {
    //     if (this.updateInteractiveViews == undefined) {
    //         this.updateInteractiveViews = [];
    //     }
    //     this.updateInteractiveViews.push(def);
    // }

    public SetHitAreaRectangle(area: Phaser.Geom.Rectangle): void
    {
        this.cachedHitArea = area;
        this.cachedHitAreaCallback = Phaser.Geom.Rectangle.Contains;

        // if button is not disabled (thats why we cache the area and callback!)
        if (this.input != null) {
            this.input.hitArea = this.cachedHitArea;
            this.input.hitAreaCallback = this.cachedHitAreaCallback;
            if (this.debug) {
                // NOTE: visual is offset, when container is scaled (but works ok)
                this.scene.input.enableDebug(this, 0xff0000);
            }
        }
    }

    public SetHitAreaPolygon(area: Phaser.Geom.Polygon): void
    {
        this.cachedHitArea = area;
        this.cachedHitAreaCallback = Phaser.Geom.Polygon.Contains;

        this.input.hitArea = this.cachedHitArea;
        this.input.hitAreaCallback = this.cachedHitAreaCallback;
        if (this.debug) {
            this.scene.input.enableDebug(this, 0xff0000);
            // this.DebugPolygonHitArea(area);
        }
    }
    
    /**
     * @param area sets specific hitArea. Ignores @see extrude parameter.
     * @param extrude number of pixels by which to extrude rect hit area defined by this.view.
     *                NOTE: ignores @see area input parameter.
     */
    public SetHitAreaFromView(view: Phaser.GameObjects.Image, extrude: number = 0): void
    {
        let area: Phaser.Geom.Rectangle = new Phaser.Geom.Rectangle(
            - extrude - view.displayWidth/2,
            - extrude - view.displayHeight/2,
            view.displayWidth + 2 * extrude, 
            view.displayHeight + 2 * extrude);
        this.cachedHitArea = area;
        this.cachedHitAreaCallback = Phaser.Geom.Rectangle.Contains;
        // console.log(this.cachedHitArea, this.cachedHitAreaCallback);

        // if button is not disabled (thats why we cache the area and callback!)
        if (this.input != null) {
            this.input.hitArea = this.cachedHitArea;
            this.input.hitAreaCallback = this.cachedHitAreaCallback;
            if (this.debug) {
                // NOTE: visual is offset, when container is scaled (but works ok)
                this.scene.input.enableDebug(this, 0xff0000);
            }
        }
    }

    /**
     * NOTE: supply all views inside an Array!!!
     * @param views 
     * @param extrude Is applied to each view in all directions
     */
    public SetHitAreaFromViews(views: any[], extrude: number = 0): void
    {
        let area: Phaser.Geom.Rectangle = GetBoundsCollection(views, extrude);

        this.cachedHitArea = area;
        this.cachedHitAreaCallback = Phaser.Geom.Rectangle.Contains;
        // console.log(this.cachedHitArea, this.cachedHitAreaCallback);

        // if button is not disabled (thats why we cache the area and callback!)
        if (this.input != null) {
            this.input.hitArea = this.cachedHitArea;
            this.input.hitAreaCallback = this.cachedHitAreaCallback;
            if (this.debug) {
                // NOTE: visual is offset, when container is scaled (but works ok)
                this.scene.input.enableDebug(this, 0xff0000);
            }
        }
    }

    private DebugHitAreaPolygon(area: Phaser.Geom.Polygon): void
    {
        // const tm: Phaser.GameObjects.Components.TransformMatrix = this.getWorldTransformMatrix();
        console.log(this.displayOriginX, this.displayOriginY, this.scaleX)
        //  Draw the polygon
        var graphics = this.scene.add.graphics({
            x: -this.displayOriginX, // offsets by pivot position
            y: -this.displayOriginY });
        this.add(graphics);
        graphics.lineStyle(4, 0xff0000);
        graphics.beginPath();
        graphics.moveTo(area.points[0].x, area.points[0].y);
        for (var i = 1; i < area.points.length; i++) {
            graphics.lineTo(area.points[i].x, area.points[i].y);
        }
        graphics.closePath();
        graphics.strokePath();
    }

    public SetInteractive(interactive: boolean, force:boolean = false): void
    {
        // console.log(this.input, this.cachedHitArea, this.cachedHitAreaCallback);

        if ((this.isInteractive != interactive) || force) {
            if (interactive) {
                if ((this.input == undefined || this.input.hitArea == undefined) ||
                this.cachedHitArea) {
                    this.setInteractive({
                        hitArea: this.cachedHitArea,
                        hitAreaCallback: this.cachedHitAreaCallback,
                        useHandCursor: true
                    });
                }
                else {
                    this.setInteractive({
                        useHandCursor: true
                    });
                }

                // this.scene.input.enableDebug(this, 0xff0000);
                if (this.cachedHitArea != undefined) {
                    this.input.hitArea = this.cachedHitArea;
                }
                if (this.cachedHitAreaCallback != undefined) {
                    this.input.hitAreaCallback = this.cachedHitAreaCallback;
                }
                if (this.debug) {
                    // NOTE: visual is offset, when container is scaled (but works ok)
                    //@ts-ignore
                    this.scene.input.enableDebug(this, 0xff0000);
                }
            }
            else {
                // CONSIDER: disable until Phaser bug gets fixed? https://github.com/photonstorm/phaser/pull/5839
                this.disableInteractive();
            }
            this.isInteractive = interactive;
            // this.UpdateViewFromInteractive();

            // in base or another mixin
            // ex: update view
            // @ts-ignore
            if (this.UpdateViewFromInteractive != undefined) {
                // @ts-ignore
                this.UpdateViewFromInteractive(this.isInteractive);
            }
        }
    }

    // // more complex but possibly force wont work sometimes so you need to externally fix?
    // public SetInteractive(interactive: boolean, force:boolean = false): void
    // {
    //     // console.log(this.cachedHitArea, this.cachedHitAreaCallback);

    //     if ((this.isInteractive != interactive) || force) {
    //         if (interactive) {
    //             if(!this.input || !this.input.hitArea) {
    //                 if ((this.cachedHitArea != undefined) &&
    //                     (this.cachedHitAreaCallback != undefined)) {
    //                         this.setInteractive({
    //                             hitArea: this.cachedHitArea,
    //                             hitAreaCallback: this.cachedHitAreaCallback,
    //                             useHandCursor: true
    //                         });
    //                         this.input.hitArea = this.cachedHitArea;
    //                         this.isInteractive = interactive;
    //                 }
    //             }
    //             else {
    //                 this.setInteractive({
    //                     useHandCursor: true
    //                 });
    //                 this.input.hitArea = this.cachedHitArea;
    //                 this.isInteractive = interactive;
    //             }

    //             // // this.scene.input.enableDebug(this, 0xff0000);
    //             // if (this.cachedHitArea != undefined) {
    //             //     this.input.hitArea = this.cachedHitArea;
    //             // }
    //             // if (this.cachedHitAreaCallback != undefined) {
    //             //     this.input.hitAreaCallback = this.cachedHitAreaCallback;
    //             // }
    //             // if (this.debug) {
    //             //     // NOTE: visual is offset, when container is scaled (but works ok)
    //             //     this.scene.input.enableDebug(this, 0xff0000);
    //             // }
    //         }
    //         else {
    //             // CONSIDER: disable until Phaser bug gets fixed? https://github.com/photonstorm/phaser/pull/5839
    //             this.disableInteractive();
    //             this.isInteractive = interactive;
    //         }
    //         // this.UpdateViewFromInteractive();

    //         // in base or another mixin
    //         // ex: update view
    //         // @ts-ignore
    //         if (this.UpdateViewFromInteractive != undefined) {
    //             // @ts-ignore
    //             this.UpdateViewFromInteractive(this.isInteractive);
    //         }
    //     }
    // }

    public IsInteractive(): boolean
    {
        return this.isInteractive;
    }
}